import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Update } from '../update';
import { FormsModule } from '@angular/forms';
import { User } from '../user';

@Component({
    selector: 'app-add',
    imports: [
        FormsModule
    ],
    templateUrl: './add.component.html',
    styleUrl: './add.component.scss'
})
export class AddComponent {

  constructor(
    public dialogRef: MatDialogRef<AddComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: AddObject
  ) {}

  save() {
    this.dialogRef.close(this.data)
  }
  close() {
    this.dialogRef.close(null)
  }
}

interface AddObject {
  user: User
  saveLabel: string
}